import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import { StatefulTooltip } from 'baseui/tooltip'

import { StyledSidebarDivButton, StyledSidebarLabel, tooltipOverrides } from '../styled-components'
import IconCarbonUnknown from '@/shared/icons/IconCarbonUnknown'
import RailHoverBubble from '@/shared/components/RailHoverBubble/RailHoverBubble'
import useRailHoverLabel from '@/shared/components/RailHoverBubble/useRailHoverLabel'

const SidebarRouterButton = ({ icon, isSelected, text, floating = false, expanded = false }) => {
  const [, theme] = useStyletron()
  const { anchorRef, geometry, show, hide } = useRailHoverLabel()
  const iconProps = {
    size: floating ? 16 : 24,
    color: isSelected && !floating ? theme.colors.white : theme.colors.primary,
    title: '',
  }
  const button = (
    <StyledSidebarDivButton
      ref={anchorRef}
      $isSelected={isSelected ?? false}
      $floating={floating}
      $expanded={expanded}
      onMouseEnter={floating ? show : undefined}
      onMouseLeave={floating ? hide : undefined}
    >
      {icon ? icon(iconProps) : <IconCarbonUnknown {...iconProps} />}
      <StyledSidebarLabel hidden={!expanded}>{text}</StyledSidebarLabel>
    </StyledSidebarDivButton>
  )

  if (expanded) return button

  if (floating) {
    return (
      <>
        {button}
        <RailHoverBubble geometry={geometry} label={text} />
      </>
    )
  }

  return (
    <StatefulTooltip content={text} popoverMargin={8} overrides={tooltipOverrides()}>
      {button}
    </StatefulTooltip>
  )
}

SidebarRouterButton.propTypes = {
  classes: PropTypes.string,
  clickHandler: PropTypes.func,
  expanded: PropTypes.bool,
  floating: PropTypes.bool,
  icon: PropTypes.func,
  isSelected: PropTypes.bool,
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
}

export default SidebarRouterButton
